import { Component, OnInit } from '@angular/core';
import { GlobalService } from '@commoncore/services/global.service';
import { AddHashTagController } from '@mainrepo/app/core/controller/AddHashTagController';
import { DependenciesModule } from '@modules/dependencies/dependencies.module';

@Component({
  standalone:true,
  selector: 'app-recent-hash-tags',
  templateUrl: './recent-hash-tags.component.html',
  styleUrls: ['./recent-hash-tags.component.scss'],
  imports:[DependenciesModule]
})
export class RecentHashTagsComponent implements OnInit {
  universalService: any;
  controller: any;
  implRef: any;
  loader:boolean = true;

  constructor(public globalService:GlobalService) { 
    this.setEnvObjects(globalService);
  }

  ngOnInit(): void {
    this.controller = AddHashTagController.getInstance(this.globalService);
    this.implRef = this.controller.addHashTagImplementation;
    this.controller.setEnvObjects(this.globalService);
    this.getRecentTag();
  }

  setEnvObjects(globalService){
    this.universalService = globalService.getUniversalServiceRef();
  }

  async getRecentTag(){
    this.loader = true;
    this.implRef.recentsTagsList = await this.controller.getRecentTags();
    await this.updateRecentData()
    console.log("recent tag list",this.implRef.recentsTagsList)
  }



  addTagToObject(tag){
    this.implRef.showTagAutoSuggestion = false;
    if(!this.universalService.connectionStatus){
      this.implRef.showNoInternetToast();
      return
    }
    this.implRef.enableButton = true;
    this.implRef.checkIfMaxTagLimitIsReached();
    this.implRef.addTagsFromRecent(tag)
  }

  updateRecentData(){
    let self = this
    self.implRef.recentsTagsList.map(function(object){
        var existingIndex = self.implRef.existingTagsList.findIndex(obj=>obj["tag"] == object["tag"])
        if(existingIndex>=0){
            object["blurTag"] = true;
        }else{
            object["blurTag"] = false;
        }
    })
    //If entered tag matches with any of recent tags list
    if(this.implRef.newTagsList.length > 0) {
      self.implRef.recentsTagsList.map(function(object){
        var existingIndex = self.implRef.newTagsList.findIndex(obj=>obj == object["tag"])
        if(existingIndex>=0){
            object["blurTag"] = true;
        }else{
            object["blurTag"] = false;
        }
      })
    }
    
    this.loader = false;
  }

}
